<!-- No RFI Found Message (Hidden When Form is Open) -->
<div *ngIf="!showForm" class="flex-1 flex flex-col items-center justify-center p-8">
  <img
    src="/assets/icons/null_response.svg"
    alt="No RFI Found"
    class="w-46 h-46 mx-auto"
  />
  <label class="text-[2rem] font-semibold font-noto mb-2"
    >Send an Email to Get Started</label
  >
  <p class="text-center text-[#000000] font-normal  mb-4">
    When You and your team will send email about this Item You can reference
    them here
  </p>
  <button
  (click)="showForm = !showForm"
  class="bg-[#E76B3F] text-white px-4 py-2 rounded">
    Compose Email
  </button>
</div>
<!-- Email Form -->
<div *ngIf="showForm" class="mx-auto bg-white p-6 rounded-lg shadow-md">
  <form [formGroup]="emailForm">
    <div class="mb-4">
       
      <label class="block text-gray-700 text-sm font-bold mb-2" for="to">To *</label>
  <div class="flex flex-wrap gap-2">
    <span *ngFor="let email of toEmails; let i = index" class="flex items-center text-white bg-[#E76B3F] px-3 py-1 rounded-full">
      {{ email }}
      <button type="button" (click)="removeEmail(i,'to')" class="ml-2 text-gray-500 hover:text-red-500 font-bold"><mat-icon class="!text-white !h-[1rem]">close</mat-icon></button>
    </span>
  </div>
          <input class=" px-2 py-4 border border-gray-300  mr-2 w-full"
                 type="text"
                 id="to"
                 formControlName="to"
                 (click)="addEmail('to')"
                 placeholder="Type email and press Enter"
                 >
  </div>
  
  <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="cc">Cc</label>
          <input class=" border border-gray-300  px-2 py-4 mr-2 w-full"
                 type="text"
                 id="cc"
                 formControlName="cc"
                 (click)="addEmail('cc')"
                 >
                 <div class="flex flex-wrap gap-2">
                  <span *ngFor="let email of ccEmails; let i = index" class="flex items-center text-white bg-[#E76B3F] px-3 py-1 rounded-full">
                    {{ email }}
                    <button type="button" (click)="removeEmail(i,'cc')" class="ml-2 text-gray-500 hover:text-red-500 font-bold"><mat-icon class="!text-white !h-[1rem]">close</mat-icon></button>
                  </span>
                </div>
  </div>
  
  <div class="mb-4">
      <label class="block text-gray-700 text-sm font-bold mb-2" for="bcc">Bcc</label>
      <input class="w-full border border-gray-300   px-2 py-4"
             type="text"
             id="bcc"
             placeholder="Type to search people"
             formControlName="bcc"
             (click)="addEmail('bcc')" 
             >
             <div class="flex flex-wrap gap-2">
              <span *ngFor="let email of bccEmails; let i = index" class="flex items-center text-white bg-[#E76B3F] px-3 py-1 rounded-full">
                {{ email }}
                <button type="button" (click)="removeEmail(i,'bcc')" class="ml-2 text-gray-500 hover:text-red-500 font-bold"><mat-icon class="!text-white !h-[1rem]">close</mat-icon></button>
              </span>
            </div>
  </div>
  
      <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="subject">Subject *</label>
          <input class="w-full border border-gray-300 rounded p-2" type="text" id="subject" formControlName="subject">
      </div>
      <p class="text-gray-500 text-sm mb-4">Note: The General Information about "{{ emailForm.get('subject')?.value }}" will be included in this email</p>
      <div class="mb-4">
          <div class="border border-gray-300 rounded p-4">
             <app-rich-textEditor
             formControlName="message"
             ></app-rich-textEditor>
          </div>
      </div>
      <div class="flex justify-between">
          <button class="bg-[#FFFFFF] text-[#E76B3F] border border-[#E76B3F]  px-4 py-2 rounded hover:bg-gray-200">Attach Files</button>
          <div>
              <button class="bg-[#FFFFFF] text-[#E76B3F] border border-[#E76B3F] mr-[10px] px-4 py-2 rounded hover:bg-gray-200">Cancel</button>
              <button class="bg-[#E76B3F] text-[#FFFFFF] px-4 !h-[41.6px] rounded hover:bg-orange-600" (click)="sendEmail()">Send</button>
          </div>
      </div>
  </form>
</div>